import React, { useRef } from 'react';
import { KebabMenuSIco } from 'assets/icons';
import { useActionMenuPresenter } from './ActionMenu.presenter';
import { Divider } from 'components/uikit/Divider/Divider';

import * as S from './ActionMenu.styles';

export const ActionMenu = ({ application, dataTest }) => {
  const ref = useRef();
  const presenter = useActionMenuPresenter({ ref, application });

  return (
    <S.Wraper ref={ref}>
      <S.OpenMenuButton
        targetRef={ref}
        onClick={presenter.toggleMenu}
        Icon={KebabMenuSIco}
        disabled={!presenter.groupedButtons.length}
        dataTest={`${dataTest}-openButton`}
      />

      {presenter.isOpen && (
        <S.Menu data-test={`${dataTest}-menu`}>
          {presenter.groupedButtons.map((group, groupIndex, groupsArray) => (
            <React.Fragment key={`group-${groupIndex}`}>
              {group.buttons.map((btn) => (
                <S.MenuItem
                  key={btn.id}
                  href={btn.href}
                  onClick={(event) => presenter.handleItemClick(event, btn.callback)}
                  data-test={`${dataTest}-${btn.id}Button`}
                >
                  {btn.label}
                </S.MenuItem>
              ))}
              {groupIndex < groupsArray.length - 1 &&
                groupsArray[groupIndex + 1].buttons.length > 0 && <Divider />}
            </React.Fragment>
          ))}
        </S.Menu>
      )}
    </S.Wraper>
  );
};
